<template>
  <div v-if="ticket" class="mt-4">
    <div class="ibox">
      <div class="ibox-title">
        Observação
      </div>

      <div class="ibox-content">
        <template v-if="editingObservation">
          <textarea
            v-model="observationDraft"
            class="form-control"
            rows="5"
            placeholder="Registre aqui informações internas sobre esta multa"
            :maxlength="observationMaxLength"
            :disabled="savingObservation"
            @keydown.esc="cancelObservation"
          />

          <div class="d-flex justify-content-between align-items-center mt-2">
            <small :class="observationDraft.length >= observationMaxLength ? 'text-danger' : 'text-muted'">
              {{ observationDraft.length }}/{{ observationMaxLength }}
            </small>

            <div>
              <button class="btn btn-outline mr-1" :disabled="savingObservation" @click="cancelObservation">
                Cancelar
              </button>
              <button
                class="btn btn-primary"
                :disabled="savingObservation || observationUnchanged"
                @click="saveObservation"
              >
                {{ savingObservation ? 'Salvando...' : 'Salvar' }}
              </button>
            </div>
          </div>
        </template>

        <template v-else>
          <p v-if="ticket.observation" class="observation-text mb-1">{{ ticket.observation }}</p>
          <p v-else class="text-muted mb-1">Nenhuma observação registrada.</p>

          <small
            v-if="ticket.observation && ticket.observation_updated_by && ticket.observation_updated_at"
            class="text-muted d-block"
          >
            Editado por {{ ticket.observation_updated_by }} em {{ ticket.observation_updated_at | datetime }}
          </small>

          <button
            v-if="$canNew('cm-frotas', 'edit_observation')"
            class="btn btn-outline mt-2"
            @click="editObservation"
          >
            {{ ticket.observation ? 'Editar' : 'Adicionar' }}
          </button>
        </template>
      </div>
    </div>

    <div class="ibox">
      <div class="ibox-title">
        Histórico de consultas desta multa
      </div>
      <TicketHistories :ticket="ticket"/>
    </div>

    <Documents :ticket="ticket"/>
  </div>

  <div v-else class="mt-4">
    <div class="ibox">
      <div class="ibox-title">
        Carregando...
      </div>
    </div>
  </div>
</template>

<script>
  import Documents from '@/components/cm-frotas/Documents'
  import EntityProxy from '@/models/EntityProxy'
  import TicketHistories from '@/components/cm-frotas/TicketHistories'
  import GlobalLoading from '@/mixins/GlobalLoading'

  import { mapMutations } from 'vuex'

  const OBSERVATION_MAX_LENGTH = 2000

  export default {
    components: { Documents, TicketHistories },
    computed: {
      observationUnchanged() {
        return this.observationDraft.trim() === (this.ticket.observation || '').trim()
      }
    },
    created() {
      this.setNameBreadcrumb('...')
      this.load()
    },
    data: () => ({
      ticket: null,
      editingObservation: false,
      observationDraft: '',
      observationMaxLength: OBSERVATION_MAX_LENGTH,
      savingObservation: false
    }),
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
      load() {
        this.axios.get(`maestro/tickets/${this.id}`)
          .then(response => this.ticket = EntityProxy.build(response.data))
          .then(() => this.setNameBreadcrumb(this.ticket.ait))
          .catch(e => this.$notify.addError(e))
      },
      editObservation() {
        this.observationDraft = this.ticket.observation || ''
        this.editingObservation = true
      },
      cancelObservation() {
        if (this.savingObservation)
          return

        this.editingObservation = false
        this.observationDraft = ''
      },
      saveObservation() {
        if (this.savingObservation || this.observationUnchanged)
          return

        this.savingObservation = true
        this.axios.put(`maestro/tickets/${this.ticket.id}/observation`, { observation: this.observationDraft })
          .then(response => {
            const data = response.data || {}
            this.$set(this.ticket, 'observation', data.observation)
            this.$set(this.ticket, 'observation_updated_by', data.observation_updated_by)
            this.$set(this.ticket, 'observation_updated_at', data.observation_updated_at)
            this.editingObservation = false
            this.observationDraft = ''
            this.$notify.add(data.observation ? 'Observação salva.' : 'Observação removida.')
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.savingObservation = false)
      }
    },
    mixins: [GlobalLoading],
    name: 'Show',
    props: {
      id: { required: false }
    }
  }
</script>

<style scoped>
  .observation-text {
    white-space: pre-wrap;
    word-break: break-word;
  }
</style>
